import { createRouter, createWebHistory } from 'vue-router';
import { progressStart, progressClose } from '@/utils/nprogress';

const routes = [
  {
    path: '/login',
    component: () => import('@/views/Login/index.vue'),
  },
  {
    path: '/bigscreen',
    component: () => import('@/views/BigScreen/index.vue'),
  },
  {
    path: '/bigscreen/detail',
    component: () => import('@/views/BigScreen/detail.vue'),
  },
  {
    path: '/',
    component: () => import('@/views/MainPage/index.vue'),
    name: 'home',
    redirect: '/toplant',
    children: [
      {
        path: '/toplant',
        name: 'toplant',
        component: () => import('@/views/Toplant/index.vue'),
      },
      {
        path: '/toplant/add',
        name: 'toplantAdd',
        component: () => import('@/views/Toplant/addToplat.vue'),
      },
      {
        path: '/toplant/edit',
        name: 'toplantEdit',
        component: () => import('@/views/Toplant/editToplat.vue'),
      },
      {
        path: '/toplant/detail',
        name: 'toplant_detail',
        props: true,
        component: () => import('@/views/Toplant/details/index.vue'),
      },
      {
        path: '/early-warning',
        name: 'EarlyWarning',
        component: () => import('@/views/EarlyWarning/index.vue'),
        // 修改这里，确保路由参数正确传递给组件
        props: (route) => ({ activeTab: route.query.tab || 'soil' }),
      },
      {
        path: '/early-warning/detail/pestdisease',
        name: 'PestDiseaseDetails',
        component: () => import('@/views/EarlyWarning/details/PestDisease.vue'),
      },
      {
        path: '/early-warning/detail/thresholdexceeded',
        name: 'ThresholdExceeded',
        component: () =>
          import('@/views/EarlyWarning/details/ThresholdExceeded.vue'),
      },
      {
        path: '/traceability',
        name: 'Traceability',
        component: () => import('@/views/Traceability/index.vue'),
      },
      {
        path: '/traceability/detail',
        name: 'TraceabilityDetails',
        component: () => import('@/views/Traceability/details/index.vue'),
      },
      {
        path: '/quality-assessment',
        name: 'QualityAssessment',
        component: () => import('@/views/QualityAssessment/index.vue'),
      },
      {
        path: '/order-form',
        name: 'OrderForm',
        component: () => import('@/views/OrderForm/index.vue'),
      },
      {
        path: '/order-form/add',
        name: 'AddOrderForm',
        component: () => import('@/views/OrderForm/addOrderForm.vue'),
      },
      {
        path: '/order-form/detail',
        name: 'OrderFormDetails',
        component: () => import('@/views/OrderForm/details/index.vue'),
      },
      {
        path: '/environmental-analysis',
        name: 'EnvironmentalAnalysis',
        component: () => import('@/views/EnvironmentalAnalysis/index.vue'),
      },
      {
        path: '/environmental-analysis/dataReport',
        name: 'EnvironmentalAnalysisReport',
        component: () =>
          import('@/views/EnvironmentalAnalysis/dataReport/index.vue'),
      },
      {
        path: '/cost-analysis',
        name: 'CostAnalysis',
        component: () => import('@/views/CostAnalysis/index.vue'),
      },
      {
        path: '/equipment',
        name: 'Equipment',
        component: () => import('@/views/Equipment/index.vue'),
      },
      {
        path: '/equipment/detail',
        name: 'EquipmentDetail',
        component: () => import('@/views/Equipment/details/index.vue'),
      },
      {
        path: '/aequipment/detail',
        name: 'AEquipmentDetail',
        component: () => import('@/views/Equipment/Adetail/index.vue'),
      },
      {
        path: '/equipment/detail/report',
        name: 'DataReport',
        component: () => import('@/views/Report/index.vue'),
      },
      {
        path: '/equipment/detail/analysis',
        name: 'DataAnalysis',
        component: () => import('@/views/Analysis/index.vue'),
      },
      {
        path: '/system',
        name: 'System',
        component: () => import('@/views/System/index.vue'),
      },
      {
        path: '/plot',
        name: 'plot',
        component: () => import('@/views/Plot/index.vue'),
      },
      {
        path: '/plot/detail',
        name: 'plotDetail',
        component: () => import('@/views/Plot/detail/index.vue'),
      },
      {
        path: '/model',
        name: 'model',
        component: () => import('@/views/ModelPage/index.vue'),
      },
      {
        path: '/model/detail',
        name: 'modelDetail',
        component: () => import('@/views/ModelPage/ModelDetail/index.vue'),
      },
      {
        path: '/model/task/detail',
        name: 'taskDetail',
        component: () => import('@/views/ModelPage/TaskDetail/index.vue'),
      },
      {
        path: '/crop',
        name: 'crop',
        component: () => import('@/views/Crop/index.vue'),
      },
      {
        path: '/crop/add',
        name: 'cropAdd',
        component: () => import('@/views/Crop/addCrop.vue'),
      },
      {
        path: '/crop/detail',
        name: 'cropDetail',
        component: () => import('@/views/Crop/detail/index.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_PUBLIC_PATH),
  routes,
});

// 路由进度条
router.beforeEach((to, from, next) => {
  progressStart();
  next();
});
router.afterEach(() => {
  progressClose();
});

export default router;
